import { render, staticRenderFns } from "./CoreDataDetail.vue?vue&type=template&id=d5e8e032&scoped=true"
import script from "./CoreDataDetail.vue?vue&type=script&lang=ts"
export * from "./CoreDataDetail.vue?vue&type=script&lang=ts"
import style0 from "./CoreDataDetail.vue?vue&type=style&index=0&id=d5e8e032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e8e032",
  null
  
)

export default component.exports